import React from 'react';
import { useTranslation } from 'react-i18next';

import { isEmpty, isUndefined } from 'lodash';
import usePermissions from '@hooks/usePermissions';
import { makeStyles } from '@mui/styles';
import { Box, Popover, Divider, Button, Typography } from '@mui/material';
import NoteList from '../NoteList/NoteList';

const useStyles = makeStyles((theme) => ({
  list: {
    marginRight: 3,
  },
  listContainer: {
    maxHeight: 160,
    height: '100%',
    '&::-webkit-scrollbar': {
      width: '4px',
      height: '40px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#DEDEDE',
      borderRadius: '4px',
    },
  },
  listItem: {
    backgroundColor: theme.palette.grey[50],
    marginBottom: 5,
    borderRadius: 4,
    flexDirection: 'column',
    '&.MuiListItem-root': {
      alignItems: 'unset',
    },
  },
  emptyList: {
    justifyContent: 'center',
    height: '144px',
    backgroundColor: theme.palette.grey[50],
    fontStyle: 'italic',
    fontSize: '14px',
    color: theme.palette.text.secondary,
  },
}));

const NotePopover = ({
  anonymisedSession,
  togglePopover,
  anchorEl,
  open,
  data,
  setOpenDialog,
  popoverClassName,
  popoverContainerClassName,
  headerClassName,
  headerButtonTitle,
  title,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const hasViewOnlyPermission = usePermissions(['see_all_sessions']);
  const preApproveSessionPermission = usePermissions(['pre_approve_session']);

  const notes = data.notes;
  const readOnlyNotes =
    data.state === 'expired' ||
    data.state === 'rejected' ||
    data.state === 'completed' ||
    data.state === 'aborted' ||
    (!isUndefined(preApproveSessionPermission) &&
      !isUndefined(hasViewOnlyPermission) &&
      data.state !== 'to-be-pre-validated' &&
      data.state !== 'into-pre-validation') ||
    (!isUndefined(hasViewOnlyPermission) &&
      data.state !== 'to-be-validated' &&
      data.state !== 'into-validation');

  return (
    <Popover
      className={popoverClassName}
      open={open}
      onClose={(e) => togglePopover(e)}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}>
      <Box className={popoverContainerClassName}>
        <Box className={headerClassName}>
          <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
            {t(title)}
          </Typography>
          {headerButtonTitle && !readOnlyNotes && (
            <Button
              color="primary"
              size="small"
              variant="text"
              style={{ fontSize: '12px' }}
              onClick={() => {
                togglePopover(null);
                setOpenDialog(true);
              }}>
              {`+${t(headerButtonTitle)}`}
            </Button>
          )}
        </Box>
        <Divider style={{ margin: '5px 0 2px' }} />
        <Box
          style={{ overflowY: 'auto' }}
          className={!isEmpty(notes) ? classes.listContainer : ''}>
          <NoteList
            listClassName={classes.list}
            listItemClassName={classes.listItem}
            emptyListClassName={classes.emptyList}
            notes={notes}
            anonymisedSession={anonymisedSession}
          />
        </Box>
      </Box>
    </Popover>
  );
};

export default NotePopover;
